var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button outlined task-quiz",on:{"click":function($event){$event.preventDefault();return _vm.onClickQuiz($event)}}},[_vm._v(_vm._s(_vm.$c( _vm.quizStarted ? 'Продолжить игру' : 'Играть' )))])}
var staticRenderFns = []

export { render, staticRenderFns }